// The statuses Zeal shows, including In Review (a PR on the task's branch is
// open) and Done once its PRs have merged. A status not listed here still
// shows in the list: the filter only hides what the user unticks.
export const TASK_STATUSES = ['To Do', 'In Progress', 'In Review', 'Idle', 'Idea', 'Icebox', 'Done', 'Archived'];
export const IDEA_STATUS = 'Idea';
export const ICEBOX_STATUS = 'Icebox';
export const HIDDEN_BY_DEFAULT = ['Done', 'Archived'];

// What the API accepts for a screenshot.
export const SCREENSHOT_TYPES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/webp': ['.webp']
};
export const MAX_SCREENSHOT_BYTES = 10 * 1024 * 1024;
